import { Component, OnInit } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { AlertService } from "../../../shared/services/alert/alert.service";
import { UploadCSRCService } from "src/app/shared";
import Swal from "sweetalert2";
import { CoreService } from "../../../shared/services";
import { first } from "rxjs/operators";
@Component({
  selector: "app-csrc-details",
  templateUrl: "./csrc-details.component.html",
  styleUrls: ["./csrc-details.component.scss"]
})
export class CsrcDetailsComponent implements OnInit {
  csrcId: any;
  sender = "csrc-details";
  error = "";
  csrc: any = {
    city_id: "",
    city_name: "",
    city_code: "",
    state_id: "",
    state_name: "",
    state_code: "",
    region_id: "",
    region_name: "",
    region_code: "",
    country_id: "",
    country_name: "",
    country_code: ""
  };

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private alertService: AlertService,
    private uploadCsrcService: UploadCSRCService,
    private coreService: CoreService
  ) { }

  ngOnInit() {
    this.route.paramMap.subscribe(params => {
      this.csrcId = params.get("id");
      if (!this.isNew()) {
        this.getCsrsById();
      }
    });
  }
  isNew() {
    return this.csrcId == "new";
  }

  onDelete() {
    Swal.fire({
      title: "Are you sure?",
      text: "CSRC data will be deleted. This action can't be reversed!",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "No, keep it"
    }).then(result => {
      if (result.value) {
        this.uploadCsrcService
          .deleteCsrc(this.csrcId)
          .pipe(first())
          .subscribe(res => {
            this.onCancel();
          });
      }
    });
  }

  onCancel() {
    this.router.navigate(["manager/csrc"]);
  }

  getCsrsById() {
    this.uploadCsrcService
      .getCsrcById(this.csrcId)
      .pipe(first())
      .subscribe(res => {
        this.csrc = res;
      });
  }

  onSave() {
    if (!this.csrc.city_id) {
      this.alertService.err(this.sender, "city id can not be blank");
      return false;
    }
    if (!this.csrc.city_name) {
      this.alertService.err(this.sender, "city name can not be blank");
      return false;
    }
    if (!this.csrc.city_code) {
      this.alertService.err(this.sender, "city code can not be blank");
      return false;
    }
    if (!this.csrc.state_id) {
      this.alertService.err(this.sender, "state id can not be blank");
      return false;
    }
    if (!this.csrc.state_name) {
      this.alertService.err(this.sender, "state name can not be blank");
      return false;
    }
    if (!this.csrc.state_code) {
      this.alertService.err(this.sender, "state code can not be blank");
      return false;
    }
    if (!this.csrc.region_id) {
      this.alertService.err(this.sender, "region id can not be blank");
      return false;
    }
    if (!this.csrc.region_name) {
      this.alertService.err(this.sender, "region name can not be blank");
      return false;
    }
    if (!this.csrc.region_code) {
      this.alertService.err(this.sender, "region code can not be blank");
      return false;
    }
    if (!this.csrc.country_id) {
      this.alertService.err(this.sender, "country id can not be blank");
      return false;
    }
    if (!this.csrc.country_name) {
      this.alertService.err(this.sender, "country name can not be blank");
      return false;
    }
    if (!this.csrc.country_code) {
      this.alertService.err(this.sender, "country code can not be blank");
      return false;
    }
    this.uploadCsrcService
      .saveCsrc(this.csrc)
      .pipe(first())
      .subscribe(res => {
        if (res["status"] == "error") {
          this.alertService.err(this.sender, res["message"]);
          return;
        }
        this.alertService.show(this.sender, "CSRC Data Saved");
        setTimeout(() => {
          this.router.navigate(["manager/csrc/"]);
        }, 1000);
      });
  }

  isNumber(evt) {
    return this.coreService.isNumeric(evt);
  }

  isChar(evt) {
    evt = evt ? evt : window.event;
    var charCode = evt.which ? evt.which : evt.keyCode;

    if (
      charCode > 31 &&
      ((charCode < 65 || charCode > 90) && (charCode < 97 || charCode > 122) && (charCode < 48 || charCode > 57))
    ) {
      return false;
    }
    return true;
  }

}
